// Builds a cumulative timeline of sales count and unlocked prize value over time.
// sales: [{ promotion_id, created_at }]  promos: [{ id, target, value_per_sale }]
export function buildTimeline(sales, promos) {
  const promoMap = {};
  promos.forEach((p) => {
    promoMap[p.id] = { target: p.target, vps: p.value_per_sale, count: 0 };
  });
  const sorted = [...(sales || [])]
    .filter((s) => promoMap[s.promotion_id])
    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

  const byDay = new Map();
  let cumVendite = 0;
  for (const s of sorted) {
    promoMap[s.promotion_id].count += 1;
    cumVendite += 1;
    let premio = 0;
    Object.values(promoMap).forEach((x) => {
      if (x.count >= x.target) premio += x.count * x.vps;
    });
    const day = new Date(s.created_at).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" });
    byDay.set(day, { date: day, vendite: cumVendite, premio: Math.round(premio * 100) / 100 });
  }
  return Array.from(byDay.values());
}
